import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors duration-200"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl font-bold whitespace-nowrap">奇妙漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isActive('/') && location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isActive('/category')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isActive('/about')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 pl-9 pr-4 py-2 text-sm rounded-full border border-background-300 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-80 bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'max-h-0'
        }`}
      >
        <div className="px-4 py-4 flex flex-col gap-2">
          <Link
            to="/"
            className="px-4 py-3 text-sm font-medium rounded-lg text-foreground-700 hover:bg-background-200 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            首页
          </Link>
          <Link
            to="/category/all"
            className="px-4 py-3 text-sm font-medium rounded-lg text-foreground-700 hover:bg-background-200 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            分类浏览
          </Link>
          <Link
            to="/about"
            className="px-4 py-3 text-sm font-medium rounded-lg text-foreground-700 hover:bg-background-200 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </header>
  );
}